<script>
  import { onMount } from 'svelte';
  import { default as Gallery } from './galerie.svelte';
  
  export let slug = null;
  
  var url, json_url = '/subject.json';
  
  var name, content = {}, rating;
  
  function load() {
    if (slug == null) return;
    let newurl = json_url+"?slug="+slug;
    if (newurl === url) return;
    url = newurl;
    fetch(url)
      .then(r => r.json())
      .then(data => {
        if (data) {
          name = data.name;
          content = data.content;
        } else {
          content = {};
        }
        window.scrollTo(0, 0);
    });
  }
  
  onMount(load);
</script>
<div class='row'>
<div class='col-12 col-md-4 order-12 order-md-1'>
{#if content.background}
<div class='d-flex align-items-center justify-content-center p-2 company-bg text-center' style='background-image: url(/img/{content.background});'>
{#if content.logo}
<img alt='{ name }' class='logo img-fluid' src='/i/{content.logo}' title='{ name }'>
{/if}
</div>
{/if}
{#if !content.background}
<div class='d-flex align-items-center justify-content-center col-md-4 pt-sm-0 pt-md-0 text-center'>
{#if content.logo}
<img alt='{ name }' class='img-fluid py-3 py-md-5' src='/i/{content.logo}' title='{ name }'>
{/if}
</div>
{/if}
{#if content.gallery_id}
<Gallery id='{content.gallery_id}'></Gallery>
{/if}
</div>
<div class='col-12 col-md-8 order-1 order-md-12'>
<div class='mx-0 overflow-hidden' style='max-width: 100%'>
<div class='row'>
<div class='col-12 px-0 pl-md-4'>
<div class='card-body'>
{#if history.length > 2}
<div class='float-right p-2 text-center'>
<a alt='Zpět' class='btn btn-outline-dark px-0 mx-0' href='javascript:history.back()' title='Zpět'>
<i class='fa fa-chevron-left'></i>
<span class='ml-1 font-weight-bold'>ZPĚT</span>
</a>
</div>
{/if}
<div class='float-left mb-4'>
<h3 class='font-weight-bold'>{#if name}{ name }{/if}</h3>
<h5>{#if content.city }{content.city}{/if}{#if content.street }, {content.street}{/if}</h5>
{#if content.phone }
<h5 title='Telefon'>
<i class='fa fa-phone'></i>
<span>{content.phone}</span>
</h5>
{/if}
{#if content.email}
<h5 title='E-mail'>
<i class='fa fa-envelope'></i>
<a href='mailto: {content.email}'>{content.email}</a>
</h5>
{/if}
<ul class='list-inline'>
{#if content.Hours}
<li class='list-inline-item' title='Otevírací doba'>
<span class='badge badge-light p-2'>
<span class='h6'>
<span class='fa fa-clock-o'></span>
<span>&nbsp;{content.Hours}</span>
</span>
</span>
</li>
{/if}
{#if content.www}
<li class='list-inline-item' title='www'>
<span class='badge badge-light p-2'>
<span class='h6'>
<span class='fa fa-globe'></span>
<a href='{content.www}'>{content.www}</a>
</span>
</span>
</li>
{/if}
{#if content.Eshop}
<li class='list-inline-item' title='E-shop'>
<span class='badge badge-secondary p-2'>
<span class='h6'>
<span class='fa fa-shopping-cart'></span>
<a href='{content.Eshop}'>E-shop</a>
</span>
</span>
</li>
{/if}
{#if content.fb}
<li class='list-inline-item' title='Facebook'>
<span class='badge badge-light p-2'>
<span class='h6'>
<img alt='fb' class='e1m' src='/a/fonts/fa/brands/facebook.svg'>
<a href='{content.fb}'>{content.fb}</a>
</span>
</span>
</li>
{/if}
{#if content.ig}
<li class='list-inline-item' title='Instagram'>
<span class='badge badge-default p-2'>
<span class='h6'>
<span class='fa-brands fa-instagram'></span>
<a href='{content.ig}'>{content.ig}</a>
</span>
</span>
</li>
{/if}
</ul>
<ul class='list-inline'>
{#if content.Wines}
<li class='list-inline-item' title='Nabídka vín'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-glass'></span>
<span>{ content.Wines }</span>
</span>
</span>
</li>
{/if}
{#if content.seats}
<li class='list-inline-item' title='Kapacita posezení'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-user'></span>
<span>{ content.seats }</span>
</span>
</span>
</li>
{/if}
{#if content.beds}
<li class='list-inline-item' title='Kapacita ubytování'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-bed'></span>
<span>{ content.beds }</span>
</span>
</span>
</li>
{/if}
{#if rating}
<li class='list-inline-item' title='Popularita'>
<span class='badge badge-success p-2'>
<span class='h6'>
<span class='fa fa-heart'></span>
<span>{rating}</span>
</span>
</span>
</li>
{/if}
</ul>
</div>
<div class='clearfix'></div>
</div>
</div>
</div>
<div class='row'>
<div class='col-12'>
<div class='card border-0 mb-4' style='max-width: 100%'>
<div class='row'>
<div class='col-md-8 px-0 pl-md-4'>
<div class='card-body'>
{#if content.about}
<p class='font-weight-bold'>{content.about}</p>
{/if}
{#if content.description}
<p>{content.description}</p>
{/if}
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>
</div>

